import t from "@emotion/styled/base";
import { Stack as c } from "@partoohub/ui";
function b() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const n = /* @__PURE__ */ t(c, process.env.NODE_ENV === "production" ? {
  target: "e11nufa70"
} : {
  target: "e11nufa70",
  label: "StyledStack"
})(process.env.NODE_ENV === "production" ? {
  name: "1urdq9i",
  styles: "padding:0 24px"
} : {
  name: "1urdq9i",
  styles: "padding:0 24px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvbW9kdWxhci1jb21wb25lbnRzL3NyYy9jb21wb25lbnRzL0J1c2luZXNzTW9kYWwvc3ViQ29tcG9uZW50cy9CdXNpbmVzc2VzQ29udGVudC9GaWx0ZXJzL0ZpbHRlcnMuc3R5bGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd3QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL21vZHVsYXItY29tcG9uZW50cy9zcmMvY29tcG9uZW50cy9CdXNpbmVzc01vZGFsL3N1YkNvbXBvbmVudHMvQnVzaW5lc3Nlc0NvbnRlbnQvRmlsdGVycy9GaWx0ZXJzLnN0eWxlZC50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFN0YWNrIH0gZnJvbSAnQHBhcnRvb2h1Yi91aSc7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTdGFjayA9IHN0eWxlZChTdGFjaylgXG4gICAgcGFkZGluZzogMCAyNHB4O1xuYDtcbiJdfQ== */",
  toString: b
});
export {
  n as StyledStack
};
